export default __webpack_public_path__ + "static/media/151-mansory.da563aea.png";